/**
 * Crea el fondo del tragamonedas
 * @param {*} scene 
 */
export function crearFondo(scene) {
  scene.fondo = scene.add.image(375, 225, "fondo");
  scene.fondo.setDepth(-100);
}